<form
  [formGroup]="form"
  class="gw-flex gw-flex-col gw-gap-x-large"
  (ngSubmit)="onSubmit()"
  novalidate
>
  <!-- Plan details + preview (single surface) -->
  <section
    class="gw-overflow-hidden gw-rounded-2xl gw-border-base gw-bg-background-elevation-2"
  >
    <div
      class="gw-flex gw-items-center gw-justify-between gw-gap-medium gw-bg-background-neutral-1 gw-px-medium gw-py-small"
    >
      <h4
        class="gw-m-0 gw-flex gw-min-w-0 gw-items-center gw-gap-small gw-text-sm gw-font-semibold gw-text-text-primary"
      >
        <gatewee-icon
          icon="@tui.book-text"
          size="16px"
          iconStyle="primary"
        ></gatewee-icon>
        <span class="gw-truncate">
          {{ 'features.feePlans.form.planDetails' | translate }}
        </span>
      </h4>
    </div>

    <div class="gw-p-medium md:gw-p-large">
      <div
        class="gw-grid gw-grid-cols-1 gw-gap-y-medium sm:gw-grid-cols-2 sm:gw-gap-x-2x-large"
      >
        <gatewee-input-v2
          [form]="form"
          controlName="name"
          type="text"
          label="features.feePlans.form.name"
          id="fee-plan-name"
          [required]="true"
          [placeholder]="'features.feePlans.form.namePlaceholder' | translate"
          [customMessages]="{
            required: ('features.feePlans.form.nameRequired' | translate),
          }"
          [submitted]="form.touched"
        ></gatewee-input-v2>
        <gatewee-input-v2
          [form]="form"
          controlName="description"
          type="text"
          label="features.feePlans.form.description"
          id="fee-plan-description"
          [placeholder]="
            'features.feePlans.form.descriptionPlaceholder' | translate
          "
          [max]="500"
          [submitted]="form.touched"
        ></gatewee-input-v2>
      </div>
    </div>

    <div
      class="gw-border-t gw-border-border-normal gw-px-medium gw-py-medium md:gw-px-large"
    >
      <div
        class="gw-grid gw-grid-cols-1 gw-gap-medium lg:gw-grid-cols-[minmax(12rem,18rem)_1fr]"
      >
        <div
          class="gw-rounded-lg gw-border gw-border-base-neutral gw-bg-background-elevation-3 gw-p-small"
        >
          <div class="gw-mb-small gw-inline-flex gw-items-center gw-gap-small">
            <gatewee-icon
              icon="@tui.calculator"
              size="16px"
              iconStyle="outline"
            ></gatewee-icon>
            <span class="gw-text-sm gw-font-semibold gw-text-text-primary">
              {{ 'features.feePlans.form.preview' | translate }}
            </span>
          </div>
          <gatewee-input-v2
            type="decimal"
            label="features.feePlans.form.previewLabel"
            id="fee-plan-preview-amount"
            [min]="0"
            [value]="previewAmount"
            (valueChange)="onPreviewAmountChange($event)"
          ></gatewee-input-v2>
        </div>
        <div
          class="gw-flex gw-flex-col gw-rounded-lg gw-border gw-border-base-neutral gw-bg-background-elevation-3 gw-px-small gw-py-2x-small"
        >
          <p
            class="gw-mb-2x-small gw-text-center gw-text-xs gw-text-text-secondary"
          >
            {{ 'features.feePlans.form.previewLabel' | translate }}
          </p>
          <h2
            class="gw-mb-2x-small gw-text-center gw-text-lg gw-font-semibold gw-text-text-primary"
          >
            {{ previewAmount | currency : 'BRL' }}
          </h2>
          <div class="gw-flex gw-items-center gw-gap-2x-small gw-mt-small">
            <gatewee-icon
              icon="@tui.alert-circle"
              size="12px"
              iconStyle="primary"
            ></gatewee-icon>
            <span class="gw-text-xs gw-leading-normal gw-text-text-secondary">
              {{ 'features.feePlans.form.previewConferenceHint' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Rules -->
  <div formArrayName="rules" class="gw-flex gw-flex-col gw-gap-large">
    <div
      *ngFor="
        let rule of rulesArray.controls;
        let ri = index;
        trackBy: trackByIndex
      "
      [formGroupName]="ri"
      class="gw-overflow-hidden gw-rounded-xl gw-bg-background-elevation-2 gw-border-base"
    >
      <div
        class="gw-flex gw-items-center gw-justify-between gw-gap-medium gw-bg-background-neutral-1 gw-px-medium gw-py-small"
      >
        <h4
          class="gw-m-0 gw-flex gw-min-w-0 gw-items-center gw-gap-small gw-text-sm gw-font-semibold gw-text-text-primary"
        >
          <gatewee-icon
            icon="@tui.filter"
            size="16px"
            iconStyle="primary"
          ></gatewee-icon>
          <span class="gw-truncate">
            {{ 'features.feePlans.form.rule' | translate }} {{ ri + 1 }}
          </span>
        </h4>
        <button
          type="button"
          class="gw-flex gw-shrink-0 gw-cursor-pointer gw-items-center gw-gap-2x-small gw-text-sm gw-text-text-negative hover:gw-text-text-negative/70"
          (click)="removeRule(ri)"
        >
          <gatewee-icon icon="@tui.trash" size="14px"></gatewee-icon>
          <span class="gw-hidden sm:gw-inline">{{
            'common.actions.remove' | translate
          }}</span>
        </button>
      </div>

      <div class="gw-flex gw-flex-col gw-gap-large gw-p-medium">
        <!-- Conditions -->
        <div
          class="gw-grid gw-grid-cols-1 gw-gap-x-large gw-gap-y-medium sm:gw-grid-cols-2 lg:gw-grid-cols-4"
        >
          <gatewee-select-v3
            formControlName="operation"
            [label]="'features.feePlans.form.operation' | translate"
            [placeholder]="'features.feePlans.form.operation' | translate"
            [items]="operationSelectItems"
          ></gatewee-select-v3>
          <gatewee-select-v3
            formControlName="paymentMethod"
            [label]="'features.feePlans.form.paymentMethod' | translate"
            [placeholder]="'features.feePlans.form.paymentMethod' | translate"
            [items]="paymentMethodSelectItems"
          ></gatewee-select-v3>
          <gatewee-select-v3
            *ngIf="isCreditCard(ri)"
            formControlName="installments"
            [label]="'features.feePlans.form.installments' | translate"
            [placeholder]="'features.feePlans.form.installments' | translate"
            [items]="installmentSelectItems"
          ></gatewee-select-v3>
          <gatewee-select-v3
            *ngIf="isCreditCard(ri)"
            formControlName="brand"
            [label]="'features.feePlans.form.brand' | translate"
            [placeholder]="'features.feePlans.form.brand' | translate"
            [items]="brandSelectItems"
          ></gatewee-select-v3>
        </div>

        <!-- Tiers (inset block — reads as one table) -->
        <div
          formArrayName="tiers"
          class="gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-p-medium"
        >
          <div
            class="gw-mb-medium gw-flex gw-items-baseline gw-justify-between gw-gap-medium"
          >
            <span
              class="gw-text-xs gw-font-semibold gw-tracking-wide gw-text-text-secondary gw-uppercase"
            >
              {{ 'features.feePlans.form.tiers' | translate }}
            </span>
          </div>

          <div
            *ngIf="hasTierError(ri)"
            class="gw-mb-medium gw-flex gw-items-center gw-gap-small gw-rounded-md gw-bg-status-negative-pale gw-px-medium gw-py-small gw-text-xs gw-text-text-negative"
          >
            <span
              class="gw-inline-flex gw-shrink-0 gw-items-center gw-justify-center gw-leading-none gw-text-status-negative"
              aria-hidden="true"
            >
              <gatewee-icon icon="@tui.alert-circle" size="14px"></gatewee-icon>
            </span>
            <span class="gw-min-w-0 gw-flex-1 gw-leading-relaxed">{{
              getTierErrorKey(ri) | translate
            }}</span>
          </div>

          <!-- Desktop column labels (aligned to tier grid) -->
          <div class="gw-flex gw-flex-col md:gw-divide-y-0 gw-gap-y-medium">
            <div
              *ngFor="
                let tier of tiersArrayFor(ri).controls;
                let ti = index;
                trackBy: trackByIndex
              "
              [formGroupName]="ti"
              class="gw-grid gw-items-start gw-bg-background-elevation-3 gw-border-base-neutral gw-p-medium gw-gap-y-medium md:gw-grid-cols-[1fr_1fr_1fr_1fr_minmax(7rem,9rem)_auto] md:gw-gap-x-large md:gw-gap-y-0 md:gw-py-small"
            >
              <gatewee-input-v2
                [form]="$any(tier)"
                controlName="minAmount"
                type="decimal"
                label="features.feePlans.form.minAmount"
                [id]="'fee-tier-' + ri + '-' + ti + '-min'"
                [min]="0"
                [submitted]="form.touched"
              ></gatewee-input-v2>
              <gatewee-input-v2
                [form]="$any(tier)"
                controlName="maxAmount"
                type="decimal"
                label="features.feePlans.form.maxAmount"
                [id]="'fee-tier-' + ri + '-' + ti + '-max'"
                [min]="0"
                [placeholder]="
                  'features.feePlans.form.maxAmountUnlimited' | translate
                "
                [submitted]="form.touched"
              ></gatewee-input-v2>
              <gatewee-input-v2
                [form]="$any(tier)"
                controlName="fixedAmount"
                type="decimal"
                label="features.feePlans.form.fixedAmount"
                [id]="'fee-tier-' + ri + '-' + ti + '-fixed'"
                [min]="0"
                [submitted]="form.touched"
              ></gatewee-input-v2>
              <gatewee-input-v2
                [form]="$any(tier)"
                controlName="rateValue"
                type="decimal"
                label="features.feePlans.form.rateValue"
                [id]="'fee-tier-' + ri + '-' + ti + '-rate'"
                [min]="0"
                [submitted]="form.touched"
              ></gatewee-input-v2>
              <div
                class="gw-flex gw-min-h-[2.75rem] gw-items-center gw-justify-between gw-gap-small gw-rounded-md gw-bg-background-elevation-2 gw-px-small gw-py-2x-small gw-text-sm gw-font-semibold gw-text-primary-brand-background md:gw-min-h-0 md:gw-items-center md:gw-gap-2x-small md:gw-justify-end md:gw-bg-transparent md:gw-p-0"
              >
                <span class="gw-text-xs gw-font-medium gw-text-text-secondary">
                  {{ 'features.feePlans.form.preview' | translate }}
                </span>
                <span class="gw-whitespace-nowrap md:gw-text-right">{{
                  computeFeePreview(ri, ti)
                }}</span>
              </div>
              <div
                class="gw-flex gw-items-end gw-justify-end md:gw-pb-2x-small"
              >
                <button
                  type="button"
                  class="gw-inline-flex gw-cursor-pointer gw-rounded-md gw-p-2x-small gw-text-text-negative gw-transition-colors hover:gw-bg-background-neutral-1 hover:gw-opacity-100 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus disabled:gw-cursor-not-allowed disabled:gw-opacity-40"
                  [attr.aria-label]="'common.actions.remove' | translate"
                  (click)="removeTier(ri, ti)"
                  [disabled]="tiersArrayFor(ri).length <= 1"
                >
                  <gatewee-icon icon="@tui.x" size="14px"></gatewee-icon>
                </button>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="gw-mt-medium gw-text-base gw-cursor-pointer gw-flex gw-items-center gw-gap-2x-small gw-text-sm gw-font-medium gw-text-primary-brand-background hover:gw-underline"
            (click)="addTier(ri)"
          >
            <gatewee-icon icon="@tui.plus" size="14px"></gatewee-icon>
            {{ 'features.feePlans.form.addTier' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <button
    type="button"
    class="gw-flex gw-w-full gw-cursor-pointer gw-items-center gw-justify-center gw-gap-medium gw-rounded-xl gw-border gw-border-dashed gw-border-border-normal gw-bg-transparent gw-py-medium gw-text-sm gw-text-text-secondary gw-transition-colors hover:gw-border-border-hover hover:gw-bg-background-neutral-1 hover:gw-text-text-primary"
    (click)="addRule()"
  >
    <gatewee-icon icon="@tui.plus" size="16px"></gatewee-icon>
    {{ 'features.feePlans.form.addRule' | translate }}
  </button>

  <div
    class="gw-flex gw-justify-end gw-gap-medium gw-border-t gw-border-border-normal gw-pt-large"
  >
    <gatewee-button
      type="button"
      variant="secondary"
      size="m"
      [title]="'common.actions.cancel' | translate"
      (clicked)="onCancel()"
    ></gatewee-button>
    <gatewee-button
      type="submit"
      variant="primary"
      size="m"
      [title]="'common.actions.save' | translate"
      [disabled]="form.invalid && form.touched"
    ></gatewee-button>
  </div>
</form>
